import { render, staticRenderFns } from "./always.vue?vue&type=template&id=4b6cc102"
import script from "./always.vue?vue&type=script&lang=js"
export * from "./always.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports